/**
 * FireGuard Live - WebSocket Service
 * Socket.IO client за real-time данни
 */
import { io } from 'socket.io-client';
import { API_ORIGIN } from './api';

const WS_URL = process.env.REACT_APP_WS_URL || API_ORIGIN;

class WebSocketService {
  constructor() {
    this.socket = null;
    this.listeners = new Map();
  }

  connect() {
    if (this.socket?.connected) {
      console.log('✅ WebSocket вече е свързан');
      return;
    }

    // Вземи token от localStorage
    const token = localStorage.getItem('fireguard_token');
    if (!token) {
      console.warn('⚠️ WebSocket: Няма authentication token. Socket.IO връзката може да не работи.');
    }

    console.log('🔌 Свързване към WebSocket:', WS_URL);

    this.socket = io(WS_URL, {
      transports: ['websocket', 'polling'],
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionAttempts: 10,
      auth: {
        token: token
      },
      query: {
        token: token
      }
    });

    this.socket.on('connect', () => {
      console.log('✅ WebSocket свързан успешно!');
    });

    this.socket.on('disconnect', (reason) => {
      console.log('⏹️ WebSocket изключен:', reason);
    });

    this.socket.on('connect_error', (error) => {
      console.error('❌ WebSocket грешка при свързване:', error);
    });

    this.socket.on('connection_status', (data) => {
      console.log('📡 Connection status:', data);
    });

    // Real-time monitoring event
    this.socket.on('realtime_monitoring', (data) => {
      this.emit('realtime_monitoring', data);
    });

    // Critical alert event
    this.socket.on('critical_alert', (data) => {
      this.emit('critical_alert', data);
      this.showCriticalAlert(data);
    });
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
      console.log('⏹️ WebSocket изключен');
    }
  }

  on(event, callback) {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, []);
    }
    this.listeners.get(event).push(callback);
  }

  off(event, callback) {
    if (this.listeners.has(event)) {
      const callbacks = this.listeners.get(event);
      const index = callbacks.indexOf(callback);
      if (index > -1) {
        callbacks.splice(index, 1);
      }
    }
  }

  emit(event, data) {
    if (this.listeners.has(event)) {
      this.listeners.get(event).forEach(callback => {
        try {
          callback(data);
        } catch (error) {
          console.error(`Грешка при извикване на listener за ${event}:`, error);
        }
      });
    }
  }

  showCriticalAlert(data) {
    // Browser notification
    if ('Notification' in window && Notification.permission === 'granted') {
      new Notification('🚨 КРИТИЧНА АЛАРМА - FireGuard', {
        body: `${data.device_code}: ${data.ai_recommendation?.substring(0, 100)}`,
        icon: '/logo192.png',
        badge: '/logo192.png',
        tag: `alert-${data.device_id}`,
        requireInteraction: true,
      });
    }

    // Play alarm sound
    try {
      const audio = new Audio('/alarm.mp3'); // Добави alarm.mp3 в public/
      audio.play().catch(e => console.log('Не може да се пусне звук:', e));
    } catch (error) {
      console.log('Alarm sound не е наличен');
    }
  }

  isConnected() {
    return this.socket?.connected || false;
  }
}

// Singleton instance
const websocketService = new WebSocketService();

export default websocketService;
